
export default {
  REGULAR: 0,
  OFFLINE: 1, // Tatap Muka
  WEBINAR: 2,
  SELF_PACED_LEARNING: 3 // Video Pembelajaran / SPL
}
